import { axiosInstance as axios } from "../axios-provider";
import { MessageEventBus } from "../../../event-bus";

import { ErrorHandler } from "../error-handler";
import { editorStateStore } from "../storage/editor-state-store";
import { HttpHeaders } from "../../../../utils/http-utils";

export class GeneratorService {
  private readonly config: {
    baseURL: string;
    timeout: number;
    headers: HttpHeaders;
    params: { type: "store"; cleanUp: boolean };
  };

  constructor(
    private baseURL: string,
    type: "store" = "store",
    cleanUp = false
  ) {
    this.config = {
      baseURL: this.baseURL,
      timeout: 10000,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {
        type: type,
        cleanUp: cleanUp,
      },
    };
  }

  errorHandler = new ErrorHandler("Code generation");
  private url(id: string): string {
    return `/api/models/${id}/generate`;
  }

  generate(
    genOptionsJson: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Promise<any> {
    return this.doGenerate(genOptionsJson);
  }

  private async doGenerate(
    genOptionsJson: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Promise<any> {
    const id = editorStateStore().getModelId;
    MessageEventBus.emit("information", {
      text: "Starting code generation...",
      id: id,
      timeout: -1,
      showProgress: true,
    });

    try {
      const initialResponse = await axios.post(this.url(id), genOptionsJson, this.config);

      if (initialResponse.status === 201) {
        // Return the response data directly
        return initialResponse;
      } else {
        return new Promise((resolve, reject) => {
          const interval = setInterval(async () => {
            try {
              const pollResponse = await axios.get(this.url(id), this.config);
              if (pollResponse.status === 201) {
                MessageEventBus.emit("success", {
                  text: "Code generation successful.",
                  id: id,
                });
                clearInterval(interval);
                resolve(pollResponse);
              } else if (pollResponse.status !== 204) {
                clearInterval(interval);
                reject();
              }
            } catch (pollError) {
              clearInterval(interval);
              reject(pollError);
            }
          }, 1000);
        });
      }
    } catch (error) {
      this.errorHandler.handle(error, id);
      throw error;
    }
  }
}
